import React, { useEffect, useRef } from "react";
import styles from "./style.module.css"
import { Link, useLocation } from "react-router-dom";
import { BsDownload } from 'react-icons/bs';
import docx from "../../../../assets/usersDashboard/docx.svg"
import pdf from "../../../../assets/usersDashboard/pdf.svg"
import documentImg from "../../../../assets/usersDashboard/document.svg"
import xl from "../../../../assets/usersDashboard/xl.svg"
import csv from "../../../../assets/usersDashboard/csv.svg"
import blue from "../../../../assets/usersDashboard/blue.png"
import white from "../../../../assets/usersDashboard/white.svg"


const Message = ({ message }) => {
  console.log(message, 'message');
  const id = JSON.parse(localStorage.getItem("userId"))
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search);
  const inboxQuery = queryParams.get('inbox');
  const ref = useRef();


  function formatTime(timestamp) {
    const now = new Date();
    const time = new Date(timestamp);

    const diffInSeconds = Math.floor((now - time) / 1000);

    if (diffInSeconds < 10) {
      return 'just now';
    } else if (diffInSeconds < 20) {
      return '20 sec ago';
    } else if (diffInSeconds < 30) {
      return '30 sec ago';
    } else if (diffInSeconds < 60) {
      return '1 min ago';
    } else if (diffInSeconds < 120) {
      return '2 mins ago';
    } else if (diffInSeconds < 180) {
      return '3 mins ago';
    } else if (diffInSeconds < 3600) {
      const minsAgo = Math.floor(diffInSeconds / 60);
      return `${minsAgo} mins ago`;
    } else if (diffInSeconds < 7200) {
      return '1 hour ago';
    } else if (diffInSeconds < 10800) {
      return '2 hours ago';
    } else if (diffInSeconds < 14400) {
      return '3 hours ago';
    } else if (time.getDate() === now.getDate() - 1) {
      const hours = time.getHours();
      const minutes = time.getMinutes();
      const formattedTime = `${hours % 12 === 0 ? 12 : hours % 12}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
      return `Yesterday ${formattedTime}`;
    } else if (time.getFullYear() === now.getFullYear()) {
      const options = { month: 'short', day: 'numeric' };
      return time.toLocaleDateString(undefined, options);
    } else {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return time.toLocaleDateString(undefined, options);
    }
  }
  function getFileTypeAndLink(url) {
    const parts = url.split('/');
    const filename = parts[parts.length - 1];
    const filenameParts = filename.split('.');

    if (filenameParts.length > 1) {
      const fileExtension = filenameParts.pop().toLowerCase();

      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
      if (imageExtensions.includes(fileExtension)) {
        return url; // Return the original link if it's an image
      } else if (fileExtension === "pdf") {
        return pdf
      }
      else if (fileExtension === "docx") {
        return docx
      }
      else if (fileExtension === "xlsx") {
        return xl
      }
      else if (fileExtension === "csv") {
        return csv
      }
      else {
        return documentImg
      }
    } else {
      return documentImg
    }
  }

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [message]);
  if (inboxQuery === "true") {
    return (
      <div
      ref={ref}
      className={`${styles.message} ${message.from === id && styles.owner}`}
    >

      {
        message?.Msg && <div className={`${styles.msgContent} ${message.from === id && styles.msgContentOwner}`}> <pre>{message?.Msg}</pre>
          <img src={message.from === id ? blue : white} alt="" className={message.from === id ? styles.tail : styles.whiteTail} />
        </div>

      }
      {message.document &&
        <div className={styles.imageDiv}>
          <img src={getFileTypeAndLink(message.document)} alt="" style={{ width: "300px", objectFit: "contain" }} />
          <Link to={message.document}><BsDownload className={styles.downloadIcon} /></Link>
        </div>
      }

      <span className={styles.timestamp}>{formatTime(message?.timestamp)}</span>

    </div>
    )
  }

  return (
    <div
    ref={ref}
    className={`${styles.message} ${message.from === id && styles.owner}`}
  >


    {
      message?.Msg && <> <div className={`${styles.msgContent} ${message.from === id && styles.msgContentOwner}`}> <pre>{message?.Msg}</pre>


        <img src={message.from === id ? blue : white} alt="" className={message.from === id ? styles.tail : styles.whiteTail} />
      </div>
      </>


    }



    {message.document &&
      <div className={styles.imageDiv}>
        <img src={getFileTypeAndLink(message.document)} onClick={() => window.open(message.document)} alt="" style={{ width: "300px", objectFit: "contain" }} />
        {/* <Link to={message.document}><BsDownload className={styles.downloadIcon} /></Link> */}

      </div>
    }
    <span className={styles.timestamp}>{formatTime(message?.timestamp)}</span>



  </div>
  );
};

export default Message;
